// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"66":"087f100a56b63d05","587":"de907d0bbfd4cfb5"}[chunkId] + ".js";
};